import { makeStyles } from '@material-ui/styles';
import React from 'react';
import cn from 'clsx';
import { PizzaEmoji } from '../../icons';

export type IconSizes = 'XX-Large' | 'X-Large' | 'Large' | 'Medium' | 'Small';

export type UserIconProps = {
    size?: IconSizes;
    photoUrl?: string;
};

const useStyles = makeStyles(
    {
        main: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            borderRadius: '50%',
        },
        imageHolder: {
            overflow: 'hidden',
            position: 'relative',
            border: 'none',
            borderRadius: '50%',
            backgroundColor: '#EBEBEB',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        'XX-Large': {
            width: 60,
            height: 60,
            fontSize: 30,
        },
        'X-Large': {
            width: 50,
            height: 50,
            fontSize: 24,
        },
        Large: {
            width: 40,
            height: 40,
            fontSize: 20,
        },
        Medium: {
            width: 32,
            height: 32,
            fontSize: 16,
        },
        Small: {
            width: 24,
            height: 24,
            fontSize: 12,
        },
        image: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
    },
    { classNamePrefix: 'UserIcon' }
);

const UserIcon: React.FC<UserIconProps> = props => {
    const { photoUrl = '', size = 'Medium' } = props;
    const classes = useStyles(props);
    const wrapperClass = cn(classes.imageHolder, classes[size]);
    return (
        <div className={classes.main}>
            <div className={wrapperClass}>
                {photoUrl ? (
                    <img
                        src={photoUrl}
                        className={classes.image}
                        width="100%"
                        height="100%"
                        alt="User image"
                    />
                ) : (
                    <PizzaEmoji />
                )}
            </div>
        </div>
    );
};

export default UserIcon;
